import { Trans, useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

export default function PageNotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center p-4 text-center">
      <div className="text-fluid-h3">
        <Trans
          i18nKey="scenes.pageNotFound.message"
          components={{ br: <br /> }}
        />
      </div>
      <h4 className="mt-6">
        <NavLink className="color-black" to={`/`}>
          {t("scenes.pageNotFound.linkText")}
        </NavLink>
      </h4>
    </div>
  );
}
